import { useState } from 'react';

const CylFitsPage = () => {
  const [name, setName] = useState('');
  const [returnMesage, setReturnMessage] = useState('');

  return (
    <>
      <section className="content-wrap">
        <h2>Cylindrical Fits</h2>
        <p id="returnmessage">{returnMesage}</p>
        <form>
          <label>
            Enter your name:
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
        </form>
      </section>
    </>
  );
};

export default CylFitsPage;
